import { render, staticRenderFns } from "./next-queries-form.view.vue?vue&type=template&id=0cf72d1a&scoped=true"
import script from "./next-queries-form.view.vue?vue&type=script&lang=ts"
export * from "./next-queries-form.view.vue?vue&type=script&lang=ts"
import style0 from "./next-queries-form.view.vue?vue&type=style&index=0&id=0cf72d1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf72d1a",
  null
  
)

export default component.exports